import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';

export const fetch = async (): Promise<ISelectOption[]> => {
  return [
    { value: 'active_now', label: 'Активные сейчас' },
    { value: 'active_before', label: 'Активные ранее' },
    { value: 'inactive', label: 'Неактивные' },
  ];
};

export const useActivityOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
